import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propArrayShape } from '../../../../../helpers/custom-prop-types';
import TagList from '../../../../Ui/Common/TagList';
const ProfessionalUnitProfessionalCount = (props) => {
    const { middleTasks } = props;
    if (!middleTasks.length) {
        return null;
    }
    return (_jsxs("div", Object.assign({ className: 'theme_row' }, { children: [_jsx("div", Object.assign({ className: 'theme_title' }, { children: "\u5F97\u610F\u306A\u30C6\u30FC\u30DE" })), _jsx(TagList, { tags: middleTasks })] })));
};
ProfessionalUnitProfessionalCount.propTypes = {
    middleTasks: propArrayShape().isRequired,
};
export default ProfessionalUnitProfessionalCount;
